import { useCallback, useState } from 'react';
import { MessageSquare } from 'react-feather';
import TablaServidor from '../../components/tabla/TablaServidor';
import { useTituloCabecera } from '../../context/tituloCabeceraContext';
import {
  COLUMNAS_NOTAS_D2L,
  TABLA_NOTAS_D2L,
} from '../../components/notasAntiguoCampus/columnasNotasD2l';
import ModalComentarioNotaD2l from '../../components/notasAntiguoCampus/ModalComentarioNotaD2l';
import {
  NOTAS_D2L_HEADQUARTER,
  SIN_VALOR,
  formatearNumero,
  formatearPuntos,
  nombreAlumno,
  tieneComentario,
} from '../../features/notasD2l';

const PARAMS = { empresaId: NOTAS_D2L_HEADQUARTER };

const NotasAntiguoCampus = () => {
  useTituloCabecera(
    'Notas antiguo campus',
    'Consulta de calificaciones del campus anterior (D2L). Solo lectura.',
  );
  const [filaSeleccionada, setFilaSeleccionada] = useState(null);
  const [modalAbierto, setModalAbierto] = useState(false);

  const verComentario = useCallback((fila) => {
    setFilaSeleccionada(fila);
    setModalAbierto(true);
  }, []);

  const renderCelda = (col, fila) => {
    if (col.id === 'numerador_puntos') {
      return formatearPuntos(fila.numerador_puntos, fila.denominador_puntos);
    }
    if (col.id === 'ponderacion') return formatearNumero(fila.ponderacion);
    if (col.id === 'denominador_puntos') return formatearNumero(fila.denominador_puntos);
    if (col.id === 'comentarios') {
      return tieneComentario(fila) ? (
        <button
          type="button"
          className="btn btn-light btn-sm"
          onClick={(e) => {
            e.stopPropagation();
            verComentario(fila);
          }}
          aria-label={`Ver comentario de ${nombreAlumno(fila) || 'alumno'}`}
          style={{ whiteSpace: 'nowrap' }}
        >
          <MessageSquare size={14} aria-hidden="true" /> Ver
        </button>
      ) : (
        SIN_VALOR
      );
    }
    return undefined;
  };

  return (
    <>
      <TablaServidor
        tablaKey={TABLA_NOTAS_D2L}
        columnas={COLUMNAS_NOTAS_D2L}
        ruta="listado-notas-d2l"
        archivo="notas-antiguo-campus"
        nombreEntidad="notas"
        placeholder="Buscar por alumno, usuario u oferta…"
        params={PARAMS}
        claveFila={(f) => `${f.empresaId}-${f.id}`}
        tituloTarjeta={(f) => nombreAlumno(f) || f.usuario || `#${f.id}`}
        renderCelda={renderCelda}
      />
      <ModalComentarioNotaD2l
        isOpen={modalAbierto}
        fila={filaSeleccionada}
        onCerrar={() => setModalAbierto(false)}
        onClosed={() => setFilaSeleccionada(null)}
      />
    </>
  );
};

export default NotasAntiguoCampus;
